import { useQuery } from "react-query"
import DataService from '../../config/DataServices'


const { getRequest } = DataService()


export const InternalTransaction = ({ id, page, size, searchText, sortField, sortOrder }) => {
    return useQuery({
        queryKey: ["Internaltransfer-history", id, page, size, searchText, sortField, sortOrder],
        queryFn: () => {
            return getRequest(`/transfer-history?page=${page}&size=${size}&search=${searchText}&sortOrder=${sortOrder}&sortField=${sortField}`)
        }
    })
}

export const ReferralTransaction = ({ id, page, size, searchText, sortField, sortOrder }) => {
    return useQuery({
        queryKey: ["Referral-list", id, page, size, searchText, sortField, sortOrder],
        queryFn: () => {
            return getRequest(`/referral-list?page=${page}&size=${size}&sortOrder=${sortOrder}&search=${searchText}&sortField=${sortField}`)
        }
    })
}


export const TopupTransaction = ({ id, page, size, searchText, sortField, sortOrder,type }) => {
    return useQuery({
        queryKey: ["Topup-history", id, page, size, searchText, sortField, sortOrder,type],
        queryFn: () => {
            return getRequest(`/card-transactions-history?page=${page}&size=${size}&search=${searchText}&sortOrder=${sortOrder}&sortField=${sortField}&type=${type}`)
        }
    })
}

export const useExportCardList = ({type}) => {
    return useQuery({
        queryKey: ["card-export" , type],
        queryFn: () => {
            return getRequest(`/export-card-history?type=${type}`)
        }
    })
}
